import React from 'react';
import {Navigate, Outlet} from 'react-router-dom'
import {isLoggedIn} from './Auth'

export default function RequireAuth(){
    return isLoggedIn() ? <Outlet /> : <Navigate to='/login' />
 }